import { instance4 } from "App/constants";
import moment from "moment";

export const urlGetHistory = "/wmsAsset/asset/list-kalibrasi";
const urlGet = "/wmsAsset/asset/list-kalibrasi";

export const statusKalibrasi = (id) => {
  if (parseInt(id) === 1) {
    return "YA";
  } else if (parseInt(id) === 2) {
    return "TIDAK";
  } else if (parseInt(id) === 3) {
    return "PENDING";
  } else {
    return "Tidak Ditemukan";
  }
};

export const RESET_STATE_FORM_FILTER = {
  id: "",
  fixasset_id: "",
  vendor_id: "",
  status: "",
  jumlah: 10,
  halaman: 1,
  tglAwal: "",
  tglAkhir: "",
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "50",
  },
  {
    id: "fixed_asset_id",
    disablePadding: false,
    label: "FIXED ASSET ID",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "tanggal",
    disablePadding: false,
    label: "TANGGAL KALIBARASI",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "vendor",
    disablePadding: false,
    label: "VENDOR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "harga",
    disablePadding: false,
    label: "HARGA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const getKalibrasi = async (formFilter, id, pages, limit) => {
  try {
    const api = await instance4.post(urlGet, {
      id: "",
      fixasset_id: id,
      vendor_id: "",
      status: "",
      tglAwal: formFilter.tgl_aktif ? moment(formFilter.tglAwal).format("YYYY-MM-DD") : "",
      tglAkhir: formFilter.tgl_aktif ? moment(formFilter.tglAkhir).format("YYYY-MM-DD") : "",
      tgl_aktif: false,
      jumlah: limit,
      halaman: pages,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
